import ReactDOM from 'react-dom';

import Leadform from './components/Leadform';
import IntlProviderWrapper from './IntlContext';
import reportWebVitals from './reportWebVitals';

import './resources/_antd.less'; // redefinition AntDesign variables
import './styles/common.scss';
import './styles/global.scss';
import './styles/icon-config.scss';
import './styles/icon.css';

declare global {
  interface Window {
    renderLeadform: ({ token, language, contactFormId, isOpen }) => void;
    visibleLeadform: (visible: boolean) => void;
    updateUserContactLeadForm?: ({ token: string }) => void;
  }
}

window.renderLeadform = ({ token, language, contactFormId, isOpen }) => {
  let rootEle: ReactDOM.Container;

  if (contactFormId) {
    rootEle = document.getElementById(contactFormId);
  } else {
    // using only for React App -> get first div element in body
    const parentNode = document.getElementsByTagName('body')[0].getElementsByTagName('div')[0];
    // create new leadform render element
    rootEle = document.createElement('div');
    rootEle.id = 'leadform';

    parentNode.appendChild(rootEle);
  }
  if (!rootEle) {
    return;
  }
  ReactDOM.render(
    <IntlProviderWrapper>
      <Leadform token={token} language={language} isOpen={isOpen} />
    </IntlProviderWrapper>,
    rootEle
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
